// Some endpoints wrap responses in pkg.Response (success/data/meta/error),
// others return the bare payload. Services run every response through unwrap()
// so consumers always see { data, meta? }.

const firstNumber = (...values) => {
  const value = values.find((item) => item !== undefined && item !== null && item !== '');
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
};

function normalizeMeta(meta) {
  if (!meta || typeof meta !== 'object') return undefined;

  const page = firstNumber(meta.current_page, meta.currentPage, meta.page);
  const perPage = firstNumber(meta.per_page, meta.perPage, meta.pageSize, meta.limit);
  const totalCount = firstNumber(
    meta.total_count,
    meta.totalCount,
    meta.total_items,
    meta.totalItems,
    meta.total_records,
    meta.totalRecords,
    meta.total,
    meta.count,
  );
  const totalPages = firstNumber(meta.total_pages, meta.totalPages, meta.pages);

  if (
    page === undefined &&
    perPage === undefined &&
    totalCount === undefined &&
    totalPages === undefined
  ) {
    return undefined;
  }

  return {
    page,
    perPage,
    totalCount,
    totalPages,
  };
}

/**
 * @template T
 * @param {unknown} payload
 * @returns {{ data: T, meta?: import('@core/types').PageMeta }}
 */
export function unwrap(payload) {
  if (payload && typeof payload === 'object') {
    const nestedMeta = normalizeMeta(payload.meta ?? payload.pagination) ?? normalizeMeta(payload);

    if ('success' in payload && 'data' in payload) {
      const dataMeta =
        payload.data && typeof payload.data === 'object'
          ? (normalizeMeta(payload.data.meta ?? payload.data.pagination) ??
            normalizeMeta(payload.data))
          : undefined;

      return { data: payload.data, meta: nestedMeta ?? dataMeta };
    }

    if ('data' in payload) {
      const dataMeta =
        payload.data && typeof payload.data === 'object'
          ? (normalizeMeta(payload.data.meta ?? payload.data.pagination) ??
            normalizeMeta(payload.data))
          : undefined;

      return { data: payload.data, meta: nestedMeta ?? dataMeta };
    }

    if (nestedMeta) {
      return { data: payload, meta: nestedMeta };
    }
  }

  return { data: payload };
}
